var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewDetailsClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0706 2.9293C12.7206 2.57923 12.153 2.57923 11.8029 2.9293L7.99984 6.73238L4.19675 2.9293C3.84668 2.57923 3.27912 2.57923 2.92905 2.9293C2.57899 3.27936 2.57899 3.84693 2.92905 4.19699L6.73214 8.00008L2.92905 11.8032C2.57899 12.1532 2.57899 12.7208 2.92905 13.0709C3.27912 13.4209 3.84668 13.4209 4.19675 13.0709L7.99984 9.26778L11.8029 13.0709C12.153 13.4209 12.7206 13.4209 13.0706 13.0709C13.4207 12.7208 13.4207 12.1532 13.0706 11.8032L9.26753 8.00008L13.0706 4.19699C13.4207 3.84693 13.4207 3.27936 13.0706 2.9293Z",
    fill: "#677B99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDetailsClose);
export default __webpack_public_path__ + "static/media/view-details-close.e53538027742e343accf3e8973d2712c.svg";
export { ForwardRef as ReactComponent };